import React from "react";
import LocationOnIcon from '@material-ui/icons/LocationOn'
import UserProfilePic from '../UserProfilePic';
import { makeStyles } from '@material-ui/core/styles';
import { CONSTANTS } from "../../utils";

const useStyles = makeStyles({
    locationWrapper: {
        position: 'relative',
        display: 'inline-flex',
        zIndex:10000
    }
});

export default function LocationWithUserPic(props) {
    const classes = useStyles();
    return (<div className={classes.locationWrapper}>
        <LocationOnIcon style={{ color: CONSTANTS.COLOR.CLEAN, fontSize: props.fontSize || '8rem' }}></LocationOnIcon>
        <UserProfilePic
            _style={{ position: 'absolute', left: '22%', top: '11%', zIndex: '1000', width: '53%' }} photoURL={props.photoURL} />
    </div>);
}
